
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits/overview",
      function () {
        return require("private-next-pages/benefits/overview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits/overview"])
      });
    }
  